// Bundle completo per il backoffice amministratore
// Include tutte le librerie: Summernote, Select2, Bootstrap-select, jQuery UI, Bootbox

try {
  const jq = require('jquery');
  const j = jq.default || jq;
  window.$ = window.jQuery = global.$ = global.jQuery = j;
} catch (e) {
  console.error('[app-admin.js] jQuery load error', e);
}

const PopperLib = require('popper.js/dist/umd/popper.js');
window.Popper = PopperLib.default || PopperLib;
require('bootstrap');

const bb = require('bootbox');
window.bootbox = bb.default || bb;

require('select2');
require('bootstrap-select');
require('bootstrap-select/js/i18n/defaults-it_IT');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/widgets/draggable');

require('summernote/dist/summernote-bs4.js');
import 'summernote/dist/summernote-bs4.css';

import './script';
import './admin';
import './nations';
